import {NgModule} from '@angular/core';
import {PropertyValuePipe} from './propertyValue.pipe';
import {FormatNumToTime, InDate, NumToShortWeekdayPipe, ShortToFullWeekdayPipe} from './time.pipe';
import {SafeUrlPipe} from './safeUrl.pipe';
import { DropdownOptionsPrepPipe } from './dropdown-options-prep.pipe';

@NgModule({
  exports: [PropertyValuePipe, NumToShortWeekdayPipe, FormatNumToTime, InDate, ShortToFullWeekdayPipe, SafeUrlPipe, DropdownOptionsPrepPipe],
  declarations: [PropertyValuePipe, NumToShortWeekdayPipe, FormatNumToTime, InDate, ShortToFullWeekdayPipe, SafeUrlPipe, DropdownOptionsPrepPipe]
})
export class PipesModule {
}
